/**
 * RTL nav fix: the permanent nav Drawer's physical side. `forceLeft` keeps the
 * extension calendar sidebar on the left; otherwise it mirrors with direction —
 * `rtl` anchors `right`, `ltr` anchors `left`. Pure + dependency-free so it is
 * unit-testable without BoardsPanel's heavy component tree.
 */
export function resolveDrawerAnchor(
  direction: "ltr" | "rtl",
  forceLeft: boolean,
): "left" | "right" {
  if (forceLeft) return "left";
  return direction === "rtl" ? "right" : "left";
}
